import Vue from 'vue'
import 'swiper/swiper.scss'
if (process.client) {
  const VueAwesomeSwiper = require('vue-awesome-swiper')
  Vue.use(VueAwesomeSwiper)
}
